import http from "../http-common";

class UploadDataService {

  deleteAWS(id){
    return http.post(`/upload/deleteaws/${id}`);
  }

  createAWS(data,userid) {
    return http.post(`/upload/aws/${userid}`, data);
  }

  create(data) {
    return http.post("/upload", data);
  }

  downloadAll() {
    return http.get(`/upload`);
  }

  download(id) {
    return http.get(`/upload/${id}`);
  }

  get(id){
    return http.get(`/upload/one/${id}`);
  }

  disable(id, data) {
    return http.put(`/upload/disable/${id}`, data);
  }

  enable(id, data) {
    return http.put(`/upload/enable/${id}`, data);
  }

  delete(id) {
    return http.delete(`/upload/${id}`);
  }

  deleteAll(userid)
  {
    return http.delete(`/upload/deleteall/${userid}`);
  }



}

export default new UploadDataService();